import {ElasticValidation, ElasticValidator} from '../validator.factory';

const removeNonWordCharacters = (text: string): string => text.replace(/\W*/g, '');
const removeBlanksSpaces = (text: string): string => text.replace(/\s/g, '');

const defaultMinLength = 3;

export class RegexValidator implements ElasticValidator {
  constructor(private readonly minLength: number = defaultMinLength) {
  }

  validate(regexString: any): ElasticValidation {
    if (regexString === undefined || regexString === null || regexString === '') {
      return {isInvalid: false};
    }

    regexString = regexString.trim();
    if (regexString === '') {
      return {isInvalid: true, errorMessage: `blanks are not allowed`};
    }

    const regexChunks = regexString.split('|')
      .map(regexChunk => regexChunk.trim())
      .filter(regexChunk => !!regexChunk);

    for (const regexChunk of regexChunks) {
      let regexProcessedString = removeNonWordCharacters(regexChunk);
      regexProcessedString = removeBlanksSpaces(regexProcessedString);

      if (regexProcessedString.length < this.minLength) {
        return {isInvalid: true, errorMessage: `${regexChunk} has less than ${this.minLength} alphanumeric characters`};
      }
    }

    return {isInvalid: false};
  }
}
